
// const scheme = {
//     /**
//      * 
//      * @param {Array} list 字段信息列表 
//      * @param {Number} userType 用户类型，1 学生，2 老师 
//      */
//     getBaseDataSchemeList (list, userType) {
//       let photoKey = '', // 图片form_key
//       photoLen = '', // 图片限制长度
//       rules = {}, // 表单规则
//       values = {}, // 表单值
//       scheme = []
//       list.filter(m => {
//         if (userType) {
//           return m.dataStatus === 1 && m.userType === userType
//         }
//         return true
//       }).forEach(m => {
//         const { fieldId, fieldType, fieldName, fieldKey, fieldValue, rank, isNull }  = m
//         const key = 'form_' + fieldId
//         let defaultVal = ''
//         let val = fieldValue
//         if (fieldType === 3) { // 图片
//             defaultVal = []
//             val = m.photoUrl && m.photoUrl.split(',').map((url, index) => ({
//                 name: url.split('?')[0].split('/').pop(),
//                 url: url,
//                 id: fieldValue.split(',')[index]
//             }))
//             photoKey = key
//             photoLen = m.photoUrl ? val.length : m.photoNum
//         }
//         rules[key] = []
//         if (isNull === 0) { // 添加规则
//             rules[key] = [{ required: true, message: fieldName + '必填项', trigger: 'blur' }]
//         }
//         if (fieldType === 2) {
//             rules[key].push({ max: 200, message: '长度在 200 个字符以内', trigger: 'blur' })
//         }
//         if (fieldType === 3) {
//           rules[key].push({ validator: function(rule, value, callback) {
//             if (value.length < photoLen) {
//                 callback(new Error('一共需提交图片' + photoLen + '张'))
//             }
//             callback()
//           }, trigger: 'blur'})
//         }
//         values[key] = val || defaultVal
//         scheme.push({
//           key: key,
//           label: fieldName,
//           formType: fieldKey,
//           rank: rank || 0,
//           required: isNull === 0
//         })
//       })
//       const sortScheme = scheme.sort((a, b) => { // 排序
//         return a.rank - b.rank
//       })
//       return {
//         photoKey,
//         photoLen,
//         rules,
//         values,
//         scheme: sortScheme,
//       }
//     }
//   }
// export default scheme
/**
 * 
 * @param {Array} list 字段信息列表 
 * @param {Number} userType 用户类型，1 学生，2 老师 
 */
export const getBaseDataSchemeList = (list, userType) => {
  let photoKey = '', // 图片form_key
  photoLen = '', // 图片限制长度
  rules = {}, // 表单规则
  values = {}, // 表单值
  scheme = []
  list.filter(m => {
    if (userType) {
      return m.dataStatus === 1 && m.userType === userType
    }
    return true
  }).forEach(m => {
    const { fieldId, fieldType, fieldName, fieldKey, fieldValue, rank, isNull }  = m
    const key = 'form_' + fieldId
    let defaultVal = ''
    let val = fieldValue
    if (fieldType === 3) { // 图片
        defaultVal = []
        val = m.photoUrl && m.photoUrl.split(',').map((url, index) => ({
            name: url.split('?')[0].split('/').pop(),
            url: url,
            id: fieldValue.split(',')[index]
        }))
        photoKey = key
        photoLen = m.photoUrl ? val.length : m.photoNum
    }
    rules[key] = []
    if (isNull === 0) { // 添加规则
        rules[key] = [{ required: true, message: fieldName + '必填项', trigger: 'blur' }]
    }
    if (fieldType === 2) {
        rules[key].push({ max: 200, message: '长度在 200 个字符以内', trigger: 'blur' })
    }
    if (fieldType === 3) {
      rules[key].push({ validator: function(rule, value, callback) {
        if (value.length < photoLen) {
            callback(new Error('一共需提交图片' + photoLen + '张'))
        }
        callback()
      }, trigger: 'blur'})
    }
    values[key] = val || defaultVal
    scheme.push({
      key: key,
      label: fieldName,
      formType: fieldKey,
      rank: rank || 0,
      required: isNull === 0
    })
  })
  const sortScheme = scheme.sort((a, b) => { // 排序
    return a.rank - b.rank
  })
  return {
    photoKey,
    photoLen,
    rules,
    values,
    scheme: sortScheme,
  }
}
// 星座列表
export const constellationsList = [
  { name: '摩羯座', range: '12/22 – 1/19' }, { name: '水瓶座', range: '1/20 – 2/18' },
  { name: '双鱼座', range: '2/19 – 3/20' }, { name: '白羊座', range: '3/21 – 4/20' },
  { name: '金牛座', range: '4/21 – 5/20' }, { name: '双子座', range: '5/21 – 6/21' },
  { name: '巨蟹座', range: '6/22 – 7/22' }, { name: '狮子座', range: '7/23 – 8/22' },
  { name: '处女座', range: '8/23 – 9/22' }, { name: '天秤座', range: '9/23 – 10/22' },
  { name: '天蝎座', range: '10/23 – 11/21' }, { name: '射手座', range: '11/22 – 12/21' },
]
// 星座展示列表
export const constellationsPickList = constellationsList.map(item => {
  item.text = `${item.name}(${item.range})`
  return item
})